module services {
    export module master {
        export class consigneeService implements interfaces.master.IConsigneeService {
            static $inject = ["$resource", "ENV", "$http", "$timeout", "generalService"];

            constructor(private $resource: ng.resource.IResourceService, private ENV: interfaces.applicationcore.serverConfig, private $http: ng.IHttpService,
                        private $timeout: ng.ITimeoutService, public generalService: interfaces.applicationcore.IGeneralService) {
            }

            //Gets list of all Terms Of Payment for a dropdown/autocomplete list
            getDropdownList(ownerEntityId: number, searchText: string): ng.resource.IResourceClass<interfaces.applicationcore.IDropdownModel> {
                return this.$resource<interfaces.applicationcore.IDropdownModel>(this.ENV.DSP_URL + "Consignee/GetDropdownList", {
                    ownerEntityId: ownerEntityId,
                    searchText: searchText
                }, {
                        query: {
                            method: 'GET',
                            isArray: true
                        }
                    });
            }

            getList(): ng.resource.IResourceClass<interfaces.master.IConsigneeDisplay> {
                return this.$resource<interfaces.master.IConsigneeDisplay>(this.ENV.DSP_URL + "Consignee/GetList", {
                    connectSearch: '@connectSearch',
                    numberRecords: '@numberRecords',
                    pageNumber: '@pageNumber',
                }, {
                        query: {
                            method: 'GET',
                            isArray: true,
                            interceptor: { response: config.appResourceDateInterceptor.parseResponseDates },
                            params: {
                                numberRecords: 25,
                                pageNumber: 1,
                            }
                        }
                    });
            }

            uploadCustomerConsigneeFromExcel(): ng.resource.IResourceClass<interfaces.applicationcore.IMessageHandler> {
                return this.$resource<interfaces.applicationcore.IMessageHandler>(this.ENV.DSP_URL + "Consignee/UploadCustomerConsigneeFromExcel", {});
            }

            getConsigneeListExcel(params: any): ng.IPromise<void> {
                var pdfDownload = document.createElement("a");
                document.body.appendChild(pdfDownload);

                var url = this.ENV.DSP_URL + 'Consignee/GetConsigneeExcel?';

                var searchObject: interfaces.applicationcore.ISearchObject = {
                    filters: [],
                    sorts: []
                }
                searchObject = params.connectSearch;

                url += 'connectSearch=' + btoa(JSON.stringify(searchObject));
                url += '&isCustomer=false';

                return this.$http({
                    method: 'GET',
                    responseType: 'arraybuffer',
                    url: url,
                }).then((response) => {
                    var filename = response.headers()['x-filename'] || 'consigneeDownload.xlsx';
                    var fileBlob = new Blob([response.data as BlobPart], { type: 'application/octet-stream' });

                    if (navigator.appVersion.toString().indexOf('.NET') > 0) { // for IE browser
                        window.navigator.msSaveBlob(fileBlob, filename);
                    } else { // for other browsers
                        var fileURL = window.URL.createObjectURL(fileBlob);
                        pdfDownload.href = fileURL;
                        pdfDownload.download = filename;
                        pdfDownload.click();
                        pdfDownload.remove();
                    }

                    this.$timeout(() => {
                        this.generalService.displayMessage("Your download has started.", Enum.EnumMessageType.Success);
                    });
                }).catch((errorResponse) => {
                    var fileBlob = new Blob([errorResponse.data], { type: 'application/json' });
                    var fileURL = window.URL.createObjectURL(fileBlob);
                    const reader = new FileReader();

                    // This fires after the blob has been read/loaded.
                    reader.addEventListener('loadend', (e: ProgressEvent) => {
                        const text = e.target['result'];

                        this.$timeout(() => {
                            this.generalService.displayMessageHandler(<interfaces.applicationcore.IMessageHandler>JSON.parse(text));
                        });
                    });

                    // Start reading the blob as text.
                    reader.readAsText(fileBlob);
                });
            }

            getConsigneeDefaults(consigneeId: number): ng.resource.IResourceClass<interfaces.master.IConsigneeDefaults> {
                return this.$resource<interfaces.master.IConsigneeDefaults>(this.ENV.DSP_URL + "Consignee/GetConsigneeDefaults", {
                    consigneeId: consigneeId,
                }, {
                        query: {
                            method: 'GET',
                            isArray: false
                        }
                    });
            }

            getConsignee(consigneeId: number): ng.resource.IResourceClass<interfaces.master.IConsigneeMaster> {
                return this.$resource<interfaces.master.IConsigneeMaster>(this.ENV.DSP_URL + "Consignee/GetConsignee", {
                    consigneeId: consigneeId
                }, {
                        query: {
                            method: 'GET',
                            isArray: false,
                            interceptor: { response: config.appResourceDateInterceptor.parseResponseDates }
                        }
                    });
            }

            save(): ng.resource.IResourceClass<interfaces.applicationcore.IMessageHandler> {
                return this.$resource<interfaces.applicationcore.IMessageHandler>(this.ENV.DSP_URL + "Consignee/Save");
            }

        }
    }
    angular.module("app").service("consigneeService", services.master.consigneeService);
}